import { FlexColumnDiv } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';
import { Label, Paragraph, rem } from '@triumph/design-system';

export const Container = styled(FlexColumnDiv)`
    gap: ${rem(4)};
`;

export const StyledLabel = styled(Label)`
    margin: 0;
    padding: 0;
`;

export const StyledParagraph = styled(Paragraph)`
    margin: 0;
    padding: 0;
    position: relative;
    top: ${rem(-4)};
`;